<template>
  <!--最外层包裹-->
  <div class="wrap">
    <!--左侧nav-->
    <div class="left" v-show='( lindex != 0 )'>
      <h3>
        <img src="@/assets/img/lieritu.png">
      </h3>
      <nav>
        <ul>
          <li :class="[ lindex == 0 ? 'xz-class' : '' ]" @click=" handLeHerf(0) ">首页</li>
          <li :class="[ lindex == 1 ? 'xz-class' : '' ]" @click=" handLeHerf(1) ">饮水思源 初心如磐</li>
          <li :class="[ lindex == 2 ? 'xz-class' : '' ]" @click=" handLeHerf(2) ">英雄 回家 </li>
          <li :class="[ lindex == 3 ? 'xz-class' : '' ]" @click=" handLeHerf(3) ">英烈褒扬进行时</li>
          <li :class="[ lindex == 4 ? 'xz-class' : '' ]" @click=" handLeHerf(4) ">英烈文化短视频展播</li>
          <li :class="[ lindex == 5 ? 'xz-class' : '' ]" @click=" handLeHerf(5) ">足不出户云祭扫</li>
          <li :class="[ lindex == 6 ? 'xz-class' : '' ]" @click=" handLeHerf(6) ">活动热度全景图</li>
        </ul>
      </nav>
      <div class="butimg"></div>
    </div>
    <!--右侧包裹-->
    <div id='warp' ref="scrollBox" class="wrapper">
      <!--滚动列-->
      <ul class="content" ref="wrap" style="transition: all 1s">
        <!--首页-->
        <div class="home">
          <div id="v1" style="width: 100%">
         <!--   <img src="@/assets/img/hometopone.jpg">-->
          </div>
          <!--  <div class="home-img"   ref="imgshow1">
              <img src="@/assets/img/fengbei.png" alt="">
            </div>-->
          <div class="home-title" ref="imgshow2">
            <img src="@/assets/img/gjfb.png" alt="">
          </div>
          <div class="home-mouse" ref="imgshow3" @click=" handLeHerf(1) ">
            <img src="@/assets/img/sbicon.png" alt="">
          </div>
        </div>
        <!--第二屏-->
        <li class="screen-tow">
          <Resistance ref='ispagetow' @change="screenTowChang()">

          </Resistance>
        </li>
        <!--第三屏-->
        <li class="screen-three">
          <Herohome ref='ispagethree1'>

          </Herohome>
        </li>
        <!--第四屏-->
        <li class="">
          <Remember ref='ispagethree' @mousewheelmr="mousewheelmr">

          </Remember>
        </li>

        <!--第五屏-->
        <li class="screen-four">
          <Remembrance ref='ispagefour'>

          </Remembrance>
        </li>
        <!--第六屏-->
        <li class="screen-five">
          <Recollection :dataAll="Screenfivedata" ref='ispagefive'>

          </Recollection>
        </li>
        <!--第七屏-->
        <li class="screen-six">
          <maprotation :dataAll="Screenfivedata">
          </maprotation>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>

  import {getUserToken} from '@/config/config.js'
  /*讲故事*/
  /* const  Resistance = ()=>import ('@/pages/Home/components/resistance')
     const  Remember= ()=>import ('@/pages/Home/components/remember')
     const  Remembrance =()=>import ('@/pages/Home/components/remembrance')
     const  Recollection  =()=>import ('@/pages/Home/components/recollection')
     const  maprotation =()=>import ('@/pages/Home/components/maprotation')*/
  import Resistance from '@/pages/Home/components/resistance'
  /*铭记历史、致敬胜利*/
  import Remember from '@/pages/Home/components/remember'
  /*英雄回家*/
  import Herohome from '@/pages/Home/components/herohome'
  /*追忆 追思 追寻 */
  import Remembrance from '@/pages/Home/components/remembrance'
  /*缅怀英烈，守护有我*/
  import Recollection from '@/pages/Home/components/recollection'
  /*地图轮转*/
  import maprotation from '@/pages/Home/components/maprotation'
  /*铭记历史*/
  import {getmjlsJsondata} from '@/api/rememberhistory.js'
  /*追忆*/
  import {getmhyldata} from '@/api/recollection.js'
  /*缅怀英烈*/
  import util from '@/assets/js/util'

  export default {
    data() {
      return {
        Screenfivedata: [],
        allHeight: [],
        lindex: 0,
      }
    },
    mounted() {
      this._initScroll();
    },
    methods: {
      /**
       * 初始化滚动
       * 1.imgHeight 获取屏幕的高
       * 2.children 拿到子元素数组
       * 3.动态将高赋值到包裹盒子中
       * 4.子元素高为屏幕的高，同时取到当前的位置和class
       * 5.开启视频
       * 6.开启首页的图标显示
       * @private
       */
      _initScroll() {
        let imgHeight = document.documentElement.clientHeight || document.body.clientHeight;
        let children = this.$refs.wrap.children;
        this.$refs.wrap.style.height = imgHeight * children.length + 'px';
        for (let i = 0; i < children.length; i++) {
          children[i].style.height = imgHeight + 'px';
          this.allHeight.push([children[i].offsetTop, children[i].getAttribute('class')]);
        }
        this._initHomeImgShow();
        document.querySelector('#warp').addEventListener('mousewheel', this.handleScroll, true) || window.addEventListener("DOMMouseScroll", this.handleScroll, false)
      },
      /**
       * 初始化图标显现
       * 1 imgshow1 首页头部logo显示
       * 2 imgshow2 首页文字显示
       * 3 imgshow2 鼠标icon显示
       */
      _initHomeImgShow() {

        setTimeout(() => {
          this.$refs.imgshow2.classList.add("opacity")
        }, 500)
        setTimeout(() => {
          this.$refs.imgshow3.classList.add("opacity")
        }, 1000)
      },
      /**
       *
       * @param e event对象 默认参数
       * 1 判断滚轮上下
       * 2 如果为上  lindex++  为下  lindex--
       * 3 根据lindex进行跳转
       */
      handleScroll(e) {
        var delta = 0;
        if (!event) event = window.event;
        if (event.wheelDelta) {//IE、chrome浏览器使用的是wheelDelta，并且值为“正负120”
          delta = event.wheelDelta / 120;
          if (window.opera) delta = -delta;//因为IE、chrome等向下滚动是负值，FF是正值，为了处理一致性，在此取反处理
        } else if (event.detail) {//FF浏览器使用的是detail,其值为“正负3”
          delta = -event.detail / 3;
        }
        if (delta < 0) {
          //向下滚动
          this.lindex++
          if (this.lindex === this.allHeight.length) {
            this.lindex = this.allHeight.length - 1;
            return
          }
        } else {
          //向上滚动
          this.lindex--;
          if (this.lindex < 0) {
            this.lindex = 0;
            return
          }
        }
        this.handleJsonSx()
        document.querySelector('.content').style.top = -this.allHeight[this.lindex][0] + 'px'
      },
      /*根据当前的index 进行跳转*/
      handLeHerf(index) {
        this.lindex = index;
        this.handleJsonSx()
        document.querySelector('.content').style.top = -this.allHeight[this.lindex][0] + 'px';
      },
      mousewheelmr(data) {
        if (data) {
          document.querySelector('#warp').removeEventListener('mousewheel', this.handleScroll, true) || window.removeEventListener("DOMMouseScroll", this.handleScroll, false)
        } else {
          document.querySelector('#warp').addEventListener('mousewheel', this.handleScroll, true) || window.addEventListener("DOMMouseScroll", this.handleScroll, false)
        }
      },


      handleJsonSx() {
        switch (this.lindex) {
          case 1:
            if (this.$refs.ispagetow) {
              this.$refs.ispagetow.$emit('bridge');
            }
            break;
          case 2:
            if (this.$refs.ispagethree1||this.$refs.ispagethree) {
              this.$refs.ispagethree.$emit('bridge', 1);
            }
            break;
          case 3:
            if (this.$refs.ispagefour) {
              this.$refs.ispagefour.$emit('bridge', 1);
            }
            break;
          case 4:
            if (this.$refs.ispagefive) {
              this.$refs.ispagefive.$emit('bridge');
            }
            break;
          default:

        }
      }



      /*接送子元素数据*/
    },
    components: {
      Resistance,
      Remember,
      Remembrance,
      Recollection,
      maprotation,
      Herohome
    }
  }
</script>
<style scoped>

  .wrap {
    width: 100%;
    height: 100%;
    display: flex;
    overflow-x: hidden;
  }
  @keyframes heart {
    from {
      transform: translate(0, 0)
    }
    to {
      transform: translate(0, 6px)
    }
  }

  @media screen and (max-width:1366px) {
    .left ul li {
      font-size: 23px !important;
    }
    .titleh3{
      font-size: 60px !important;
    }
  }

  .opacity {
    opacity: 1 !important;
  }

  #v1 {
    width: 100%;
    height: 100%;
    opacity: 0.7;
    overflow: hidden;
    background:center center / cover  url("../../assets/img/hometopone.jpg");
  }

  .wrapper {
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
  }

  .content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    transition: all 1s;
  }

  #warp {
    overflow-y: hidden;
    overflow-x: hidden;
    float: right;
    flex: 1;
  }

  .home {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  /*  .home-img {
      display: none;
      position: absolute;
      top: -20px;
      width: 200px;
      height: 740px;
      text-align: center;
      opacity: 0;
      transition: all 2s ease;
    }*/

  .home-img > img {
    width: 100%;
    height: 100%;
  }

  .home-title {
    position: absolute;
    text-align: center;
    top: 350px;
    width: 100%;
    height: 200px;
    opacity: 0;
    transition: all 2s ease;
  }

  .home-mouse {
    text-align: center;
    position: absolute;
    bottom: 45px;
    width: 100%;
    height: 85px;
    opacity: 0;
    transition: all 2s ease;
    cursor: pointer;
  }
  li>.home-mouse{
    opacity: 1;
    text-align: center;
    position: absolute;
    bottom: 5px;
    width: calc(100% - 275px);
    height: 85px;
    transition: all 2s ease;
    cursor: pointer;
    z-index: 10000;
  }

  .home-mouse > img {
    height: 100%;
    animation: heart 0.3s ease-in-out 0.5s infinite alternate;

  }

  .content > li {
    position: relative;
    width: 100%;
    overflow: hidden;
    background: url("../../assets/img/bigimgbj2.jpg");
    background-size: 100% 100%;
  }

  .Screenone {
    width: 1920px;
    height: 100%;
  }

  .Five {
    background-color: saddlebrown;
  }

  .titleimg {
    width: 527px;
    height: 93.4px;
    margin-top: 66.4px;
  }

  .left {
    position: relative;
    float: left;
    width: 275.7px;
    height: 100%;
    box-sizing: border-box;
    background: url("../../assets/img/red-bac.png")
  }

  .left > h3 {
    width: 95%;
    margin-left: 2.5%;
    margin-top: 50px;
    margin-bottom: 50px;
  }

  .left > h3 > img {
    width: 100%;
    height: 100%;
  }

  .left ul {
    display: inline-block;
    text-align: center;
  }

  .left > nav {
    text-align: center;
  }

  .xz-class {
    background-image: url("../../assets/img/buttonimg.png") !important;
    color: azure !important;
  }
  .left ul li {
    height: 46px;
    width: 229px;
    margin-bottom: 30px;
    background-image: url("../../assets/img/buttonicon.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    text-align: center;
    line-height: 46px;
    font-size: 20px;
    font-family: Source Han Serif SC;
    font-weight: 800;
    color: rgba(153, 0, 0, 1);
    cursor: pointer;
  }



  /*  .butimg {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 446.3px;
      height: 333px;
      background: url("../../assets/img/leftnavbuttom.png") no-repeat;
      background-size: 100% 100%;
      z-index: 1000;
    }*/

  .titleh3 {
    text-align: center;
    font-size: 75px;
    font-weight: 400;
    line-height: 215px;
    color: rgba(247, 239, 207, 1);
  }

  .details {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1000;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Home/index.vue